import BaseApi from './baseApi';
import IAuthentication from '../models/IAuthentication';
import { createDataAccessStore } from '@/store/stores/DataAcess-store';
import { StringObjectArrayListTuple, StringObjectTuple } from '../types/types';
import DataAcessApi from './DataAccessApi';
import { BORGood } from '../models/BORGood';
import IDataTable from '../models/IDataTable';
import { BORGoodSave } from '../models/BORGoodSave';
export default class BORGoodsApi extends BaseApi {
    idUser : string = "";
    dataAcess: any = null;

    constructor() {
        super("dataaccess", "Inbounds");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.dataAcess = createDataAccessStore('dataAcessListCitiesMain');
        this.dataAcess.FormId = "Inbounds";
    }

    async GetSuggestions(idTransaction: string, goodName: string) : Promise<BORGood[]> {
        let parameters : StringObjectTuple[];
        parameters = [['IdTransaction', idTransaction], ['Name', goodName]];
        const api = new DataAcessApi("Inbounds1");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("BOR_GOODS_GET_GOOD_BY_NAME", parameters, []);
            return this.MapToBORGoods(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async SaveGood(idTransaction: string, goods: BORGoodSave[]) : Promise<BORGoodSave[]> {
        let result: any[][] = this.extractValues(goods);
        let parameters : StringObjectTuple[];
        parameters = [['IdTransaction', idTransaction]];
        let structures: StringObjectArrayListTuple[];
        structures = [["GoodsList", result]];
        const api = new DataAcessApi("Inbounds2");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("BOR_GOODS_SAVE", parameters, structures);
            return this.MapToBORGoodSave(data, idTransaction);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    MapToBORGoodSave(data: IDataTable, idTransaction: string): BORGoodSave[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }
    
        return data.records.map(record => {
            return {
                id: record.id || "",
                name: record.name || "",
                code: record.code || "",
                sku: record.sku || "",
                eanCode: record.eanCode || "",
                amount: record.amount || 0,
                specifications: record.specifications || "",
                user: record.user || "",
                idTransaction: idTransaction
            };
        });
    }

    MapToBORGoods(data: IDataTable): BORGood[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }
    
        return data.records.map(record => {
            return {
                id: record.id || "",
                name: record.name || "",
                sku: record.sku || "",
                eanCode: record.eanCode || "",
                coincidence: record.coincidence || 0,
                goodsPerCase: record.goodPerCase || 0
            };
        });
    }
}
